/* tslint:disable */

declare var Object: any;
export interface TeodempsurveydetailInterface {
  "transactionCode": string;
  "empId": string;
  "surveyCode": string;
  "libCode": string;
  "answer"?: string;
  "answerText"?: string;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
}

export class Teodempsurveydetail implements TeodempsurveydetailInterface {
  "transactionCode": string;
  "empId": string;
  "surveyCode": string;
  "libCode": string;
  "answer": string;
  "answerText": string;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  constructor(data?: TeodempsurveydetailInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Teodempsurveydetail`.
   */
  public static getModelName() {
    return "Teodempsurveydetail";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Teodempsurveydetail for dynamic purposes.
  **/
  public static factory(data: TeodempsurveydetailInterface): Teodempsurveydetail{
    return new Teodempsurveydetail(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Teodempsurveydetail',
      plural: 'Teodempsurveydetails',
      path: 'Teodempsurveydetails',
      properties: {
        "transactionCode": {
          name: 'transactionCode',
          type: 'string'
        },
        "empId": {
          name: 'empId',
          type: 'string'
        },
        "surveyCode": {
          name: 'surveyCode',
          type: 'string'
        },
        "libCode": {
          name: 'libCode',
          type: 'string'
        },
        "answer": {
          name: 'answer',
          type: 'string'
        },
        "answerText": {
          name: 'answerText',
          type: 'string'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Teodempsurveydetail.ts